import {
  JsonapiEntity,
  attribute,
  entity,
  link,
  meta,
} from 'jsonapi-transformers';

export enum PublishActionStatus {
  PROCESSING = 'processing',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
}

@entity({ type: 'list_publish_actions' })
export class ListPublishAction extends JsonapiEntity<ListPublishAction> {
  @attribute() status: PublishActionStatus;
  @meta({ name: 'list_etag' })
  listEtag?: string;
  @link({ name: 'review' })
  reviewUrl?: string;
}
